import { render, staticRenderFns } from "./AmountDetailPayAuthority.vue?vue&type=template&id=8e11f6d2&scoped=true"
import script from "./AmountDetailPayAuthority.vue?vue&type=script&lang=ts"
export * from "./AmountDetailPayAuthority.vue?vue&type=script&lang=ts"
import style0 from "./AmountDetailPayAuthority.vue?vue&type=style&index=0&id=8e11f6d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e11f6d2",
  null
  
)

export default component.exports